import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend } from "recharts";

const barData = [
  { name: "Electronics", visits: 420 },
  { name: "Furniture", visits: 320 },
  { name: "Clothes", visits: 280 },
  { name: "Books", visits: 240 },
  { name: "Home Appliances", visits: 190 },
  { name: "Sports & Fitness", visits: 160 },
  { name: "Tools", visits: 140 },
  { name: "Vehicles", visits: 120 },
  { name: "Others", visits: 80 },
];

const pieData = [
  { name: "Buyers", value: 45 },
  { name: "Sellers", value: 25 },
  { name: "Donators", value: 20 },
  { name: "Giveaways", value: 10 },
];

const COLORS = [
  "hsl(145, 65%, 42%)",
  "hsl(145, 45%, 55%)",
  "hsl(145, 30%, 35%)",
  "hsl(0, 0%, 40%)",
];

const chartTickStyle = { 
  fontSize: 12,
  border: "1px solid hsl(0,0%,16%)",
  borderRadius: 8,
};

const tooltipStyle = {
  backgroundColor: "hsl(0,0%,8%)",
  border: "1px solid hsl(0,0%,16%)",
  borderRadius: 8,
  color: "hsl(0,0%,95%)",
  fontSize: 12,
};

const CategoryCharts = () => {
  return (
    <div className="mt-12">
      <h2 className="mb-6 font-heading text-2xl font-bold text-foreground">
        Analytics
      </h2>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        {/* Bar chart */}
        <div className="rounded-lg border border-border bg-card p-5">
          <h3 className="mb-4 text-sm font-medium text-muted-foreground">
            Most Visited Categories
          </h3>
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={barData}>
              <XAxis
                dataKey="name"
                tick={tooltipStyle}
                axisLine={false}
                tickLine={false}
                angle={-35}
                textAnchor="end"
                height={80}
              />
              <YAxis tick={tooltipStyle} axisLine={false} tickLine={false} />
              <Tooltip contentStyle={tooltipStyle} />
              <Bar dataKey="visits" fill="hsl(145,65%,42%)" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* Pie chart */}
        <div className="rounded-lg border border-border bg-card p-5">
          <h3 className="mb-4 text-sm font-medium text-muted-foreground">
            Most Active Mode
          </h3>
          <ResponsiveContainer width="100%" height={260}>
            <PieChart>
              <Pie
                data={pieData}
                cx="50%"
                cy="50%"
                innerRadius={55}
                outerRadius={90}
                paddingAngle={4}
                dataKey="value"
                stroke="none"
              >
                {pieData.map((_, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Legend formatter={(value) => <span style={{ color: "hsl(0,0%,75%)", fontSize: 12 }}>{value}</span>} />
              <Tooltip contentStyle={chartTickStyle} />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default CategoryCharts;
